import PropTypes from 'prop-types';
import React from 'react';

import {
  BenchmarkGridSlice,
  propTypesDataBenchmarkGrid,
} from '../../../../shared/components/Slices/BenchmarkGrid';
import {
  CTASlice,
  propTypesDataCTA,
} from '../../../../shared/components/Slices/CTA';
import {
  CalloutSlice,
  propTypesDataCallout,
} from '../../../../shared/components/Slices/Callout';
import {
  EventCardsSlice,
  propTypesDataEventCards,
} from '../../../../shared/components/Slices/EventCards';
import {
  GridWithGrades,
  propTypesDataGridWithGrades,
} from '../../../../shared/components/Slices/GridWithGrades';
import {
  GridWithMainColumnSlice,
  propTypesDataGridWithMainColumn,
} from '../../../../shared/components/Slices/GridWithMainColumn';
import {
  GridWithMainLinesSlice,
  propTypesDataGridWithMainLines,
} from '../../../../shared/components/Slices/GridWithMainLines';
import {
  ImageSlice,
  propTypesDataImage,
} from '../../../../shared/components/Slices/Image';
import {
  ProsConsGridSlice,
  propTypesDataProsConsGrid,
} from '../../../../shared/components/Slices/ProsConsGrid';
import {
  QuoteSlice,
  propTypesDataQuote,
} from '../../../../shared/components/Slices/Quote';
import {
  QuoteLineSlice,
  propTypesDataQuoteLine,
} from '../../../../shared/components/Slices/QuoteLine';
import {
  SimpleGridSlice,
  propTypesDataSimpleGrid,
} from '../../../../shared/components/Slices/SimpleGrid';
import {
  SimpleGridWithIllustration,
  propTypesDataSimpleGridWithIllustration,
} from '../../../../shared/components/Slices/SimpleGridWithIllustration';
import {
  SneakTitleSlice,
  propTypesDataSneakTitle,
} from '../../../../shared/components/Slices/SneakTitle';
import {
  TableOfContentSlice,
  propTypesDataTableOfContent,
} from '../../../../shared/components/Slices/TableOfContent';
import {
  TakeAwayParagraphSlice,
  propTypesDataTakeAwayParagraph,
} from '../../../../shared/components/Slices/TakeAwayParagraph';
import {
  TextSlice,
  propTypesDataText,
} from '../../../../shared/components/Slices/Text';
import {
  VideoSlice,
  propTypesDataVideo,
} from '../../../../shared/components/Slices/Video';

import { DocumentType } from '../../../../shared/constants/Enums';

// We import each dedicated slice component and then
// iterate over each slice to render the correct one
// https://prismic.io/docs/technologies/template-slices-gatsby
export const SliceZonePost = ({ slices, localization }) => {
  if (!slices) {
    return null;
  }

  const sliceComponents = {
    cta: CTASlice,
    full_width_image: ImageSlice,
    quote: QuoteSlice,
    table_of_content: TableOfContentSlice,
    text: TextSlice,
    event_cards: EventCardsSlice,
    video: VideoSlice,
    sneak_title: SneakTitleSlice,
    callout: CalloutSlice,
    takeaway_paragraph: TakeAwayParagraphSlice,
    quote_line: QuoteLineSlice,
    pros_cons_grid: ProsConsGridSlice,
    simple_grid: SimpleGridSlice,
    grid_with_main_column: GridWithMainColumnSlice,
    grid_with_main_lines: GridWithMainLinesSlice,
    benchmark_grid: BenchmarkGridSlice,
    simple_grid_with_illustration: SimpleGridWithIllustration,
    grid_with_grades: GridWithGrades,
  };

  return slices.map((slice, index) => {
    const SliceComponent = sliceComponents[slice.slice_type];
    if (SliceComponent) {
      return (
        <SliceComponent
          documentType={DocumentType.POST}
          key={`${slice}-${index}`}
          localization={localization}
          slice={slice}
        />
      );
    }
    return null;
  });
};

SliceZonePost.propTypes = {
  /**
   * Slice list used in a Post.
   */
  slices: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.shape(propTypesDataBenchmarkGrid),
      PropTypes.shape(propTypesDataCallout),
      PropTypes.shape(propTypesDataCTA),
      PropTypes.shape(propTypesDataEventCards),
      PropTypes.shape(propTypesDataGridWithMainColumn),
      PropTypes.shape(propTypesDataGridWithMainLines),
      PropTypes.shape(propTypesDataImage),
      PropTypes.shape(propTypesDataProsConsGrid),
      PropTypes.shape(propTypesDataQuote),
      PropTypes.shape(propTypesDataQuoteLine),
      PropTypes.shape(propTypesDataSimpleGrid),
      PropTypes.shape(propTypesDataSneakTitle),
      PropTypes.shape(propTypesDataTableOfContent),
      PropTypes.shape(propTypesDataTakeAwayParagraph),
      PropTypes.shape(propTypesDataText),
      PropTypes.shape(propTypesDataVideo),
      PropTypes.shape(propTypesDataSimpleGridWithIllustration),
      PropTypes.shape(propTypesDataGridWithGrades),
    ])
  ),
};
